module.exports = __webpack_public_path__ + "img/4.16f6105a.jpg";